// This file is auto-generated by @hey-api/openapi-ts

import type {
  ApiError,
  DeleteChatSessionsByChatSessionIdData,
  DeleteChatSessionsByChatSessionIdResponses,
  DeleteEntitiesByFpIdAnnotationsByAnnotationIdData,
  DeleteEntitiesByFpIdAnnotationsByAnnotationIdResponses,
  DeleteEntitiesByFpIdData,
  DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyData,
  DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyResponses,
  DeleteEntitiesByFpIdResponses,
  DeleteEntitiesByFpIdTagsByTagIdData,
  DeleteEntitiesByFpIdTagsByTagIdResponses,
  DeleteEntitiesByFpIdVaultData,
  DeleteEntitiesByFpIdVaultResponses,
  DeleteOrgAgentsMcpServersByServerIdData,
  DeleteOrgAgentsMcpServersByServerIdResponses,
  DeleteOrgAppMetaAndroidByMetaIdData,
  DeleteOrgAppMetaAndroidByMetaIdResponses,
  DeleteOrgAppMetaIosByMetaIdData,
  DeleteOrgAppMetaIosByMetaIdResponses,
  DeleteOrgArtifactsByArtifactIdData,
  DeleteOrgArtifactsByArtifactIdResponses,
  DeleteOrgCredentialsByCredentialIdData,
  DeleteOrgCredentialsByCredentialIdResponses,
  DeleteOrgEntityStatusesBySlugData,
  DeleteOrgEntityStatusesBySlugResponses,
  DeleteOrgFrequentNotesByFrequentNoteIdData,
  DeleteOrgFrequentNotesByFrequentNoteIdResponses,
  DeleteOrgListsByListIdData,
  DeleteOrgListsByListIdEntriesByListEntryIdData,
  DeleteOrgListsByListIdEntriesByListEntryIdResponses,
  DeleteOrgListsByListIdResponses,
  DeleteOrgReviewQueuesByIdData,
  DeleteOrgReviewQueuesByIdResponses,
  DeleteOrgReviewTeamsByIdData,
  DeleteOrgReviewTeamsByIdResponses,
  DeleteOrgTagsByTagIdData,
  DeleteOrgTagsByTagIdResponses,
  GetChatSessionsByChatSessionIdData,
  GetChatSessionsByChatSessionIdResponses,
  GetChatSessionsByChatSessionIdWireMessagesData,
  GetChatSessionsByChatSessionIdWireMessagesResponses,
  GetChatSessionsData,
  GetChatSessionsResponses,
  GetData,
  GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsData,
  GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsResponses,
  GetEntitiesByFpIdAnnotationsData,
  GetEntitiesByFpIdAnnotationsResponses,
  GetEntitiesByFpIdAvailableAdhocVendorsData,
  GetEntitiesByFpIdAvailableAdhocVendorsResponses,
  GetEntitiesByFpIdBusinessesData,
  GetEntitiesByFpIdBusinessesResponses,
  GetEntitiesByFpIdBusinessOwnersData,
  GetEntitiesByFpIdBusinessOwnersResponses,
  GetEntitiesByFpIdData,
  GetEntitiesByFpIdDataData,
  GetEntitiesByFpIdDataResponses,
  GetEntitiesByFpIdDocumentsByDocumentIdentifierData,
  GetEntitiesByFpIdDocumentsByDocumentIdentifierResponses,
  GetEntitiesByFpIdDocumentsData,
  GetEntitiesByFpIdDocumentsResponses,
  GetEntitiesByFpIdDupesData,
  GetEntitiesByFpIdDupesResponses,
  GetEntitiesByFpIdInvestigationsArtifactsByKeyData,
  GetEntitiesByFpIdInvestigationsArtifactsByKeyResponses,
  GetEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionData,
  GetEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionResponses,
  GetEntitiesByFpIdLabelData,
  GetEntitiesByFpIdLabelResponses,
  GetEntitiesByFpIdLinkedBankAccountsData,
  GetEntitiesByFpIdLinkedBankAccountsResponses,
  GetEntitiesByFpIdLivenessData,
  GetEntitiesByFpIdLivenessResponses,
  GetEntitiesByFpIdMatchSignalsData,
  GetEntitiesByFpIdMatchSignalsResponses,
  GetEntitiesByFpIdOnboardingsByOnboardingIdData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdDataData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdDataResponses,
  GetEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsResponses,
  GetEntitiesByFpIdOnboardingsByOnboardingIdResponses,
  GetEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsResponses,
  GetEntitiesByFpIdOnboardingsByOnboardingIdTraceData,
  GetEntitiesByFpIdOnboardingsByOnboardingIdTraceResponses,
  GetEntitiesByFpIdOnboardingsData,
  GetEntitiesByFpIdOnboardingsResponses,
  GetEntitiesByFpIdResponses,
  GetEntitiesByFpIdReviewsData,
  GetEntitiesByFpIdReviewsResponses,
  GetEntitiesByFpIdRiskSignalsData,
  GetEntitiesByFpIdRiskSignalsResponses,
  GetEntitiesByFpIdRuleSetResultByRuleSetResultIdData,
  GetEntitiesByFpIdRuleSetResultByRuleSetResultIdResponses,
  GetEntitiesByFpIdRuleSetResultData,
  GetEntitiesByFpIdRuleSetResultResponses,
  GetEntitiesByFpIdTagsData,
  GetEntitiesByFpIdTagsResponses,
  GetEntitiesByFpIdTimelineData,
  GetEntitiesByFpIdTimelineResponses,
  GetEntitiesByFpIdUserInsightsData,
  GetEntitiesByFpIdUserInsightsResponses,
  GetEntitiesByFpIdVaultData,
  GetEntitiesByFpIdVaultResponses,
  GetEntitiesClientTokenData,
  GetEntitiesClientTokenResponses,
  GetEntitiesVaultDecryptByTokenData,
  GetFailData,
  GetHeadersData,
  GetHealthData,
  GetHealthEnclaveData,
  GetHealthEnclaveDecryptData,
  GetHealthEnclaveDecryptResponses,
  GetHealthEnclaveResponses,
  GetOrgAgentsByAgentIdBuilderData,
  GetOrgAgentsByAgentIdBuilderResponses,
  GetOrgAgentsByAgentIdData,
  GetOrgAgentsByAgentIdHistoryData,
  GetOrgAgentsByAgentIdHistoryResponses,
  GetOrgAgentsByAgentIdReleasesData,
  GetOrgAgentsByAgentIdReleasesResponses,
  GetOrgAgentsByAgentIdResponses,
  GetOrgAgentsByAgentIdSummaryData,
  GetOrgAgentsByAgentIdSummaryResponses,
  GetOrgAgentsData,
  GetOrgAgentsMcpServersData,
  GetOrgAgentsMcpServersResponses,
  GetOrgAgentsMetricsData,
  GetOrgAgentsMetricsResponses,
  GetOrgAgentsResponses,
  GetOrgAgentsRunsByWorkflowIdData,
  GetOrgAgentsRunsByWorkflowIdResponses,
  GetOrgAgentsTaskCatalogData,
  GetOrgAgentsTaskCatalogResponses,
  GetOrgAgentsTemplatesData,
  GetOrgAgentsTemplatesResponses,
  GetOrgAgentsToolsData,
  GetOrgAgentsToolsResponses,
  GetOrgApiKeysData,
  GetOrgApiKeysResponses,
  GetOrgAppearencesByAppearanceIdData,
  GetOrgAppearencesByAppearanceIdResponses,
  GetOrgAppearencesData,
  GetOrgAppearencesResponses,
  GetOrgAppMetaAndroidData,
  GetOrgAppMetaAndroidResponses,
  GetOrgAppMetaIosData,
  GetOrgAppMetaIosResponses,
  GetOrgArtifactsByArtifactIdData,
  GetOrgArtifactsByArtifactIdVersionsByVersionIdData,
  GetOrgArtifactsByArtifactIdVersionsData,
  GetOrgArtifactsByArtifactIdVersionsResponses,
  GetOrgArtifactsData,
  GetOrgArtifactsResponses,
  GetOrgAuditEventsData,
  GetOrgAuditEventsResponses,
  GetOrgAuthGoogleOauthData,
  GetOrgAuthRolesData,
  GetOrgAuthRolesResponses,
  GetOrgBoardThreadsData,
  GetOrgBoardThreadsResponses,
  GetOrgClientSecurityConfigData,
  GetOrgClientSecurityConfigResponses,
  GetOrgCredentialsData,
  GetOrgCredentialsResponses,
  GetOrgData,
  GetOrgEntityStatusesByIdData,
  GetOrgEntityStatusesByIdResponses,
  GetOrgEntityStatusesData,
  GetOrgEntityStatusesResponses,
  GetOrgFootprintWrappedData,
  GetOrgFrequentNotesData,
  GetOrgFrequentNotesResponses,
  GetOrgGraphsByGraphIdNodesByNodeIdContextData,
  GetOrgGraphsByGraphIdNodesByNodeIdContextResponses,
  GetOrgGraphsByGraphIdSearchData,
  GetOrgGraphsByGraphIdSearchResponses,
  GetOrgInvestigationsByIdData,
  GetOrgInvestigationsByIdResponses,
  GetOrgInvestigationsByIdTraceData,
  GetOrgInvestigationsByIdTraceResponses,
  GetOrgInvoicePreviewData,
  GetOrgInvoicePreviewResponses,
  GetOrgListsByIdTimelineData,
  GetOrgListsByIdTimelineResponses,
  GetOrgListsByListIdData,
  GetOrgListsByListIdEntriesData,
  GetOrgListsByListIdEntriesResponses,
  GetOrgListsByListIdResponses,
  GetOrgListsData,
  GetOrgListsResponses,
  GetOrgMemberData,
  GetOrgMemberInProgressOnboardingsData,
  GetOrgMemberInProgressOnboardingsResponses,
  GetOrgMemberResponses,
  GetOrgMembersData,
  GetOrgMembersResponses,
  GetOrgMetricsData,
  GetOrgMetricsResponses,
  GetOrgOnboardingsByIdData,
  GetOrgOnboardingsByIdResponses,
  GetOrgPlaybooksByIdData,
  GetOrgPlaybooksByIdResponses,
  GetOrgPlaybooksByPlaybookIdDeploymentsData,
  GetOrgPlaybooksByPlaybookIdDeploymentsResponses,
  GetOrgPlaybooksByPlaybookIdVersionsByVersionIdData,
  GetOrgPlaybooksByPlaybookIdVersionsByVersionIdResponses,
  GetOrgPlaybooksByPlaybookIdVersionsData,
  GetOrgPlaybooksByPlaybookIdVersionsResponses,
  GetOrgPlaybooksData,
  GetOrgPlaybooksEditSessionsByEditSessionIdData,
  GetOrgPlaybooksEditSessionsByEditSessionIdResponses,
  GetOrgPlaybooksGalleryData,
  GetOrgPlaybooksGalleryResponses,
  GetOrgPlaybooksResponses,
  GetOrgPlaybooksTemplatesData,
  GetOrgPlaybooksTemplatesResponses,
  GetOrgProxyConfigsByConfigIdLogsData,
  GetOrgProxyConfigsByConfigIdLogsResponses,
  GetOrgProxyConfigsByProxyConfigIdData,
  GetOrgProxyConfigsByProxyConfigIdResponses,
  GetOrgProxyConfigsData,
  GetOrgProxyConfigsResponses,
  GetOrgReportingEmbedData,
  GetOrgReportingEmbedResponses,
  GetOrgResponses,
  GetOrgReviewAgentsData,
  GetOrgReviewAgentsResponses,
  GetOrgReviewAgentsReviewsData,
  GetOrgReviewAgentsReviewsResponses,
  GetOrgReviewKindsData,
  GetOrgReviewKindsResponses,
  GetOrgReviewQueuesByIdData,
  GetOrgReviewQueuesByIdResponses,
  GetOrgReviewQueuesByQueueIdMetricsData,
  GetOrgReviewQueuesByQueueIdMetricsResponses,
  GetOrgReviewQueuesByQueueIdReviewsData,
  GetOrgReviewQueuesByQueueIdReviewsResponses,
  GetOrgReviewQueuesData,
  GetOrgReviewQueuesResponses,
  GetOrgReviewTeamsByIdData,
  GetOrgReviewTeamsByIdResponses,
  GetOrgReviewTeamsData,
  GetOrgReviewTeamsResponses,
  GetOrgRiskSignalMetricsData,
  GetOrgRiskSignalMetricsResponses,
  GetOrgRiskSignalsSpecData,
  GetOrgRiskSignalsSpecResponses,
  GetOrgRolesData,
  GetOrgRolesResponses,
  GetOrgSdkVersionData,
  GetOrgSdkVersionResponses,
  GetOrgTagsData,
  GetOrgTagsResponses,
  GetOrgVaultDrAwsPreEnrollmentData,
  GetOrgVaultDrAwsPreEnrollmentResponses,
  GetOrgVaultDrStatusData,
  GetOrgVaultDrStatusResponses,
  GetOrgVendorIntegrationsData,
  GetOrgVendorIntegrationsResponses,
  GetOrgWebhookPortalData,
  GetOrgWebhookPortalResponses,
  GetPrivateAccessRequestsData,
  GetPrivateAccessRequestsResponses,
  GetPrivateGraphsByGraphIdData,
  GetPrivateGraphsByGraphIdResponses,
  GetResponses,
  GetRoStatusData,
  GetStatus2Data,
  GetStatusData,
  PatchChatSessionsByChatSessionIdData,
  PatchChatSessionsByChatSessionIdResponses,
  PatchEntitiesByFpIdAnnotationsByAnnotationIdData,
  PatchEntitiesByFpIdAnnotationsByAnnotationIdResponses,
  PatchEntitiesByFpIdStatusesData,
  PatchEntitiesByFpIdStatusesResponses,
  PatchEntitiesByFpIdVaultData,
  PatchEntitiesByFpIdVaultResponses,
  PatchEntitiesVaultData,
  PatchEntitiesVaultResponses,
  PatchOrgAgentsByAgentIdBuilderData,
  PatchOrgAgentsByAgentIdBuilderResponses,
  PatchOrgAgentsByAgentIdData,
  PatchOrgAgentsByAgentIdResponses,
  PatchOrgAgentsMcpServersByServerIdData,
  PatchOrgAgentsMcpServersByServerIdResponses,
  PatchOrgApiKeysByIdData,
  PatchOrgApiKeysByIdResponses,
  PatchOrgAppearencesByAppearanceIdData,
  PatchOrgAppearencesByAppearanceIdResponses,
  PatchOrgAppMetaAndroidByMetaIdData,
  PatchOrgAppMetaAndroidByMetaIdResponses,
  PatchOrgAppMetaIosByMetaIdData,
  PatchOrgAppMetaIosByMetaIdResponses,
  PatchOrgArtifactsByArtifactIdData,
  PatchOrgArtifactsByArtifactIdResponses,
  PatchOrgClientSecurityConfigData,
  PatchOrgClientSecurityConfigResponses,
  PatchOrgData,
  PatchOrgEntityStatusesBySlugData,
  PatchOrgEntityStatusesBySlugResponses,
  PatchOrgListsByListIdData,
  PatchOrgListsByListIdResponses,
  PatchOrgMemberData,
  PatchOrgMemberResponses,
  PatchOrgMembersByTenantUserIdData,
  PatchOrgMembersByTenantUserIdResponses,
  PatchOrgPlaybooksByIdData,
  PatchOrgPlaybooksByIdResponses,
  PatchOrgPlaybooksEditSessionsByEditSessionIdData,
  PatchOrgPlaybooksEditSessionsByEditSessionIdResponses,
  PatchOrgProxyConfigsByProxyConfigIdData,
  PatchOrgProxyConfigsByProxyConfigIdResponses,
  PatchOrgResponses,
  PatchOrgReviewAgentsByIdData,
  PatchOrgReviewAgentsByIdResponses,
  PatchOrgReviewKindsByIdData,
  PatchOrgReviewKindsByIdResponses,
  PatchOrgReviewQueuesByIdData,
  PatchOrgReviewQueuesByIdResponses,
  PatchOrgReviewTeamsByIdData,
  PatchOrgReviewTeamsByIdResponses,
  PatchOrgRolesByTenantRoleIdData,
  PatchOrgRolesByTenantRoleIdResponses,
  PatchPrivateAccessRequestsByRequestIdData,
  PatchPrivateAccessRequestsByRequestIdResponses,
  PostBusinessesByFpBidVaultByIdentifierUploadData,
  PostBusinessesByFpBidVaultByIdentifierUploadResponses,
  PostChatSessionsData,
  PostChatSessionsResponses,
  PostEntitiesByFpIdActionsData,
  PostEntitiesByFpIdActionsResponses,
  PostEntitiesByFpIdAgentsExecutionByIdData,
  PostEntitiesByFpIdAgentsExecutionByIdResponses,
  PostEntitiesByFpIdAnnotationsData,
  PostEntitiesByFpIdAnnotationsResponses,
  PostEntitiesByFpIdBusinessOwnersKycLinksData,
  PostEntitiesByFpIdBusinessOwnersKycLinksResponses,
  PostEntitiesByFpIdDecryptAmlHitsBySignalIdData,
  PostEntitiesByFpIdDecryptAmlHitsBySignalIdResponses,
  PostEntitiesByFpIdInvestigationsArtifactsData,
  PostEntitiesByFpIdInvestigationsArtifactsResponses,
  PostEntitiesByFpIdLabelData,
  PostEntitiesByFpIdLabelResponses,
  PostEntitiesByFpIdRequestFpReviewData,
  PostEntitiesByFpIdRequestFpReviewResponses,
  PostEntitiesByFpIdSentilinkBySignalIdData,
  PostEntitiesByFpIdSentilinkBySignalIdResponses,
  PostEntitiesByFpIdTagsData,
  PostEntitiesByFpIdTagsResponses,
  PostEntitiesByFpIdTokenData,
  PostEntitiesByFpIdTokenResponses,
  PostEntitiesByFpIdVaultByIdentifierUploadData,
  PostEntitiesByFpIdVaultByIdentifierUploadResponses,
  PostEntitiesByFpIdVaultDecryptData,
  PostEntitiesByFpIdVaultDecryptResponses,
  PostEntitiesByFpIdVaultIntegrityData,
  PostEntitiesByFpIdVaultIntegrityResponses,
  PostEntitiesByFpIdVaultValidateData,
  PostEntitiesByFpIdVaultValidateResponses,
  PostEntitiesData,
  PostEntitiesExtractPromptData,
  PostEntitiesExtractPromptResponses,
  PostEntitiesResponses,
  PostEntitiesSearchCountData,
  PostEntitiesSearchCountResponses,
  PostEntitiesSearchData,
  PostEntitiesSearchResponses,
  PostEntitiesVaultByIdentifierUploadData,
  PostEntitiesVaultByIdentifierUploadResponses,
  PostEntitiesVaultDecryptData,
  PostEntitiesVaultDecryptResponses,
  PostEntitiesVaultValidateData,
  PostEntitiesVaultValidateResponses,
  PostInvestigationsByInvestigationIdSourcesData,
  PostInvestigationsByInvestigationIdSourcesResponses,
  PostOrgAgentsBuilderData,
  PostOrgAgentsBuilderExplainRulesData,
  PostOrgAgentsBuilderExplainRulesResponses,
  PostOrgAgentsBuilderGenerateRulesData,
  PostOrgAgentsBuilderGenerateRulesResponses,
  PostOrgAgentsBuilderResponses,
  PostOrgAgentsByAgentIdBuilderPublishData,
  PostOrgAgentsByAgentIdBuilderPublishResponses,
  PostOrgAgentsByAgentIdBuilderRestoreData,
  PostOrgAgentsByAgentIdBuilderRestoreResponses,
  PostOrgAgentsByAgentIdBuilderSuggestionsAcceptData,
  PostOrgAgentsByAgentIdBuilderSuggestionsAcceptResponses,
  PostOrgAgentsByAgentIdBuilderSuggestionsRejectData,
  PostOrgAgentsByAgentIdBuilderSuggestionsRejectResponses,
  PostOrgAgentsByAgentIdRunData,
  PostOrgAgentsByAgentIdRunResponses,
  PostOrgAgentsMcpServersByServerIdOauthStartData,
  PostOrgAgentsMcpServersByServerIdOauthStartResponses,
  PostOrgAgentsMcpServersData,
  PostOrgAgentsMcpServersOauthCompleteData,
  PostOrgAgentsMcpServersOauthCompleteResponses,
  PostOrgAgentsMcpServersOauthStartData,
  PostOrgAgentsMcpServersOauthStartResponses,
  PostOrgAgentsMcpServersResponses,
  PostOrgApiKeysByIdDeactivateData,
  PostOrgApiKeysByIdDeactivateResponses,
  PostOrgApiKeysByIdRevealData,
  PostOrgApiKeysByIdRevealResponses,
  PostOrgApiKeysData,
  PostOrgApiKeysResponses,
  PostOrgAppearencesByAppearanceIdProposalData,
  PostOrgAppearencesByAppearanceIdProposalResponses,
  PostOrgAppearencesData,
  PostOrgAppearencesResponses,
  PostOrgAppMetaAndroidByMetaIdRevealData,
  PostOrgAppMetaAndroidByMetaIdRevealResponses,
  PostOrgAppMetaAndroidData,
  PostOrgAppMetaAndroidResponses,
  PostOrgAppMetaIosByMetaIdRevealData,
  PostOrgAppMetaIosByMetaIdRevealResponses,
  PostOrgAppMetaIosData,
  PostOrgAppMetaIosResponses,
  PostOrgArtifactsByArtifactIdVersionsData,
  PostOrgArtifactsByArtifactIdVersionsResponses,
  PostOrgArtifactsData,
  PostOrgArtifactsResponses,
  PostOrgAuthAssumeRoleData,
  PostOrgAuthAssumeRoleResponses,
  PostOrgAuthDocsTokenData,
  PostOrgAuthDocsTokenResponses,
  PostOrgAuthLoginData,
  PostOrgAuthLoginResponses,
  PostOrgAuthLogoutData,
  PostOrgAuthLogoutResponses,
  PostOrgAuthMagicLinkData,
  PostOrgAuthMagicLinkResponses,
  PostOrgAuthMcpCompleteData,
  PostOrgAuthMcpCompleteResponses,
  PostOrgAuthSamlSsoData,
  PostOrgAuthSamlSsoResponses,
  PostOrgBoardThreadsByThreadIdDeactivateData,
  PostOrgBoardThreadsByThreadIdDeactivateResponses,
  PostOrgCredentialsByCredentialIdDecryptData,
  PostOrgCredentialsByCredentialIdDecryptResponses,
  PostOrgCredentialsData,
  PostOrgCredentialsResponses,
  PostOrgFrequentNotesData,
  PostOrgFrequentNotesResponses,
  PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsData,
  PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsResponses,
  PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesData,
  PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesResponses,
  PostOrgInvestigationsSearchData,
  PostOrgInvestigationsSearchResponses,
  PostOrgListsByListIdEntriesData,
  PostOrgListsByListIdEntriesResponses,
  PostOrgListsData,
  PostOrgListsResponses,
  PostOrgMembersByTenantUserIdDeactivateData,
  PostOrgMembersByTenantUserIdDeactivateResponses,
  PostOrgMembersData,
  PostOrgMembersResponses,
  PostOrgOnboardingConfigsByIdCopyData,
  PostOrgOnboardingConfigsByIdCopyResponses,
  PostOrgOnboardingSessionData,
  PostOrgOnboardingSessionResponses,
  PostOrgOnboardingSessionValidateData,
  PostOrgOnboardingSessionValidateResponses,
  PostOrgOnboardingsData,
  PostOrgOnboardingsResponses,
  PostOrgPercyEntitiesQueryData,
  PostOrgPercyEntitiesQueryResponses,
  PostOrgPlaybooksByPlaybookIdDeploymentsData,
  PostOrgPlaybooksByPlaybookIdDeploymentsResponses,
  PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishData,
  PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishResponses,
  PostOrgPlaybooksEditSessionsByEditSessionIdCommitData,
  PostOrgPlaybooksEditSessionsByEditSessionIdCommitResponses,
  PostOrgPlaybooksEditSessionsByEditSessionIdModernizeData,
  PostOrgPlaybooksEditSessionsByEditSessionIdModernizeResponses,
  PostOrgPlaybooksEditSessionsByEditSessionIdRestoreData,
  PostOrgPlaybooksEditSessionsByEditSessionIdRestoreResponses,
  PostOrgPlaybooksEditSessionsByEditSessionIdRunData,
  PostOrgPlaybooksEditSessionsByEditSessionIdRunResponses,
  PostOrgPlaybooksEditSessionsData,
  PostOrgPlaybooksEditSessionsResponses,
  PostOrgProxyConfigsByProxyConfigIdDeactivateData,
  PostOrgProxyConfigsByProxyConfigIdDeactivateResponses,
  PostOrgProxyConfigsData,
  PostOrgProxyConfigsResponses,
  PostOrgReviewAgentsData,
  PostOrgReviewAgentsResponses,
  PostOrgReviewKindsData,
  PostOrgReviewKindsResponses,
  PostOrgReviewQueuesByQueueIdNextData,
  PostOrgReviewQueuesByQueueIdNextResponses,
  PostOrgReviewQueuesData,
  PostOrgReviewQueuesResponses,
  PostOrgReviewsByIdSelfAssignData,
  PostOrgReviewsByIdSelfAssignResponses,
  PostOrgReviewsByIdSelfUnassignData,
  PostOrgReviewsByIdSelfUnassignResponses,
  PostOrgReviewsByIdStartData,
  PostOrgReviewsByIdStartResponses,
  PostOrgReviewTeamsData,
  PostOrgReviewTeamsResponses,
  PostOrgRolesByTenantRoleIdDeactivateData,
  PostOrgRolesByTenantRoleIdDeactivateResponses,
  PostOrgRolesData,
  PostOrgRolesResponses,
  PostOrgTagsData,
  PostOrgTagsResponses,
  PostOrgVaultDrAwsPreEnrollmentData,
  PostOrgVaultDrAwsPreEnrollmentResponses,
  PostOrgVaultDrEnrollData,
  PostOrgVaultDrEnrollResponses,
  PostOrgVaultDrRevealWrappedRecordKeysData,
  PostOrgVaultDrRevealWrappedRecordKeysResponses,
  PostOrgVendorIntegrationsByIntegrationIdCredentialsData,
  PostOrgVendorIntegrationsByIntegrationIdCredentialsResponses,
  PostOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealData,
  PostOrgVendorIntegrationsData,
  PostOrgVendorIntegrationsResponses,
  PostPrivateAccessRequestsData,
  PostPrivateAccessRequestsResponses,
  PostPrivateAssumeData,
  PostPrivateAssumeResponses,
  PostVaultProxyLogsByLogIdRevealData,
  PostVaultProxyLogsByLogIdRevealResponses,
  PutOrgAppearencesByAppearanceIdLogoData,
  PutOrgAppearencesByAppearanceIdLogoResponses,
  PutOrgLogoData,
  PutOrgLogoResponses,
  PutOrgMemberFeaturePreviewsData,
  PutOrgMemberFeaturePreviewsResponses,
} from '@onefootprint/request-types/dashboard';
import { type Client, type Options as ClientOptions, formDataBodySerializer, type TDataShape } from './client';
import { client as _heyApiClient, buildResponseTransformer } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const get = <ThrowOnError extends boolean = true>(options?: Options<GetData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetResponses, ApiError, ThrowOnError>({
    url: '/',
    ...options,
  });
};

/**
 * Sets the contents of the provided identifier for the provided business vault to the HTTP request body. Supports fp_bid or ext_id. Useful for uploading large objects.
 */
export const postBusinessesByFpBidVaultByIdentifierUpload = <ThrowOnError extends boolean = true>(
  options: Options<PostBusinessesByFpBidVaultByIdentifierUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostBusinessesByFpBidVaultByIdentifierUploadResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/businesses/{fpBid}/vault/{identifier}/upload',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List chat sessions for the authenticated tenant user.
 */
export const getChatSessions = <ThrowOnError extends boolean = true>(
  options?: Options<GetChatSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetChatSessionsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/chat_sessions',
    ...options,
  });
};

/**
 * Create or resume a percy chat session.
 */
export const postChatSessions = <ThrowOnError extends boolean = true>(
  options: Options<PostChatSessionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostChatSessionsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/chat_sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Soft-delete a chat session by setting its deactivated_at timestamp.
 */
export const deleteChatSessionsByChatSessionId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteChatSessionsByChatSessionIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteChatSessionsByChatSessionIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/chat_sessions/{chatSessionId}',
    ...options,
  });
};

/**
 * Get a chat session includingthe status of its underlying percy session.
 */
export const getChatSessionsByChatSessionId = <ThrowOnError extends boolean = true>(
  options: Options<GetChatSessionsByChatSessionIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetChatSessionsByChatSessionIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/chat_sessions/{chatSessionId}',
    ...options,
  });
};

/**
 * Update a chat session's title or starred state.
 */
export const patchChatSessionsByChatSessionId = <ThrowOnError extends boolean = true>(
  options: Options<PatchChatSessionsByChatSessionIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchChatSessionsByChatSessionIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/chat_sessions/{chatSessionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List rendered wire-message rows for a chat session in insertion order. Each row is a single `WsMessage`. Sessions persisted before wire messages existed fall back to deriving messages from the raw transcript just in time.
 */
export const getChatSessionsByChatSessionIdWireMessages = <ThrowOnError extends boolean = true>(
  options: Options<GetChatSessionsByChatSessionIdWireMessagesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetChatSessionsByChatSessionIdWireMessagesResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/chat_sessions/{chatSessionId}/wire_messages',
    responseTransformer: buildResponseTransformer([['data', 'wire_content']]),
    ...options,
  });
};

/**
 * Create a new entity, initializing its vault with the provided data
 */
export const postEntities = <ThrowOnError extends boolean = true>(options: Options<PostEntitiesData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns information about the provided client auth token.
 */
export const getEntitiesClientToken = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesClientTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesClientTokenResponses, ApiError, ThrowOnError>({
    url: '/entities/client_token',
    ...options,
  });
};

/**
 * Extract entity name, kind, and investigation prompt from free-text input using LLM
 */
export const postEntitiesExtractPrompt = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesExtractPromptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesExtractPromptResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/extract_prompt',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * This doesn't actually have side effects despite being a POST. The request simply needs to be sent as an HTTP body since it contains PII, and many HTTP clients don't support GET with an HTTP body
 * View list of entities (business or user) matching the search query.
 */
export const postEntitiesSearch = <ThrowOnError extends boolean = true>(
  options?: Options<PostEntitiesSearchData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostEntitiesSearchResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * This doesn't actually have side effects despite being a POST. The request simply needs to be sent as an HTTP body since it contains PII, and many HTTP clients don't support GET with an HTTP body
 * Count the number of entities (business or user) matching the search query.
 */
export const postEntitiesSearchCount = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesSearchCountData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesSearchCountResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/search/count',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Works for either person or business entities. Updates data in a vault given a short-lived, entity-scoped client token.
 */
export const patchEntitiesVault = <ThrowOnError extends boolean = true>(
  options: Options<PatchEntitiesVaultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchEntitiesVaultResponses, ApiError, ThrowOnError>({
    url: '/entities/vault',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Works for either person or business entities. Decrypts the specified list of fields given a short-lived, entity-scoped client token
 */
export const postEntitiesVaultDecrypt = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesVaultDecryptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesVaultDecryptResponses, ApiError, ThrowOnError>({
    url: '/entities/vault/decrypt',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Works for either person or business entities. Decrypts and downloads the entity's data as specified by the provided token.
 */
export const getEntitiesVaultDecryptByToken = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesVaultDecryptByTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    url: '/entities/vault/decrypt/{token}',
    ...options,
  });
};

/**
 * Checks if provided data is valid before adding it to the vault given a short-lived, user-scoped client token. Returns an HTTP 200 if there are no validation errors, or HTTP 400 with context describing validation errors if any.
 */
export const postEntitiesVaultValidate = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesVaultValidateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesVaultValidateResponses, ApiError, ThrowOnError>({
    url: '/entities/vault/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Works for either person or business entities. Updates data in a vault given a short-lived, entity-scoped client token.
 */
export const postEntitiesVaultByIdentifierUpload = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesVaultByIdentifierUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesVaultByIdentifierUploadResponses, ApiError, ThrowOnError>({
    url: '/entities/vault/{identifier}/upload',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Retrieve business insights for a given fp_bid and onboarding.
 */
export const getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsights = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpBid}/onboardings/{onboardingId}/business_insights',
    ...options,
  });
};

/**
 * Works for either person or business entities. Supports fp_id or ext_id. Updates data in a vault.
 */
export const postEntitiesByFpIdVaultByIdentifierUpload = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdVaultByIdentifierUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostEntitiesByFpIdVaultByIdentifierUploadResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/vault/{identifier}/upload',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Deactivate an entity.
 */
export const deleteEntitiesByFpId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteEntitiesByFpIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteEntitiesByFpIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}',
    ...options,
  });
};

/**
 * View details of a specific entity (business or user)
 */
export const getEntitiesByFpId = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}',
    ...options,
  });
};

/**
 * Decrypts structured information about the Agent Execution output
 */
export const postEntitiesByFpIdAgentsExecutionById = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdAgentsExecutionByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdAgentsExecutionByIdResponses, ApiError, ThrowOnError>(
    {
      security: [
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Percy-Chat-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
      ],
      url: '/entities/{fpId}/agents/execution/{id}',
      ...options,
    },
  );
};

/**
 * Store artifacts as onboarding data for an investigation
 */
export const postEntitiesByFpIdInvestigationsArtifacts = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdInvestigationsArtifactsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostEntitiesByFpIdInvestigationsArtifactsResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/investigations/artifacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Retrieve a single investigation artifact by filename, decrypted
 */
export const getEntitiesByFpIdInvestigationsArtifactsByKey = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdInvestigationsArtifactsByKeyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdInvestigationsArtifactsByKeyResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/investigations/artifacts/{key}',
    ...options,
  });
};

/**
 * Get the latest active session for an investiation
 */
export const getEntitiesByFpIdInvestigationsByInvestigationIdActiveSession = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdInvestigationsByInvestigationIdActiveSessionResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/investigations/{investigationId}/active_session',
    ...options,
  });
};

/**
 * Deactivate an investigation artifact by key
 */
export const deleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKey = <ThrowOnError extends boolean = true>(
  options: Options<DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteEntitiesByFpIdInvestigationsByWorkflowIdArtifactsByKeyResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/investigations/{workflowId}/artifacts/{key}',
    ...options,
  });
};

/**
 * View a user's label
 */
export const getEntitiesByFpIdLabel = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdLabelData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdLabelResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/label',
    ...options,
  });
};

/**
 * Update a user's label
 */
export const postEntitiesByFpIdLabel = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdLabelData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdLabelResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/label',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * View a user's tags
 */
export const getEntitiesByFpIdTags = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdTagsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/tags',
    ...options,
  });
};

/**
 * Tag a user
 */
export const postEntitiesByFpIdTags = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdTagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdTagsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Untag a user
 */
export const deleteEntitiesByFpIdTagsByTagId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteEntitiesByFpIdTagsByTagIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteEntitiesByFpIdTagsByTagIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/tags/{tagId}',
    ...options,
  });
};

/**
 * Atomically apply the provided list of actions.
 */
export const postEntitiesByFpIdActions = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdActionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdActionsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/actions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Gets the annotations for a user.
 */
export const getEntitiesByFpIdAnnotations = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdAnnotationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdAnnotationsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/annotations',
    ...options,
  });
};

/**
 * Creates a new freeform annotation.
 */
export const postEntitiesByFpIdAnnotations = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdAnnotationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdAnnotationsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/annotations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Deletes an existing annotation.
 */
export const deleteEntitiesByFpIdAnnotationsByAnnotationId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteEntitiesByFpIdAnnotationsByAnnotationIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteEntitiesByFpIdAnnotationsByAnnotationIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/annotations/{annotationId}',
    ...options,
  });
};

/**
 * Updates an existing annotation.
 */
export const patchEntitiesByFpIdAnnotationsByAnnotationId = <ThrowOnError extends boolean = true>(
  options: Options<PatchEntitiesByFpIdAnnotationsByAnnotationIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchEntitiesByFpIdAnnotationsByAnnotationIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/annotations/{annotationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all available adhoc vendors
 */
export const getEntitiesByFpIdAvailableAdhocVendors = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdAvailableAdhocVendorsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdAvailableAdhocVendorsResponses, ApiError, ThrowOnError>(
    {
      security: [
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Percy-Chat-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
      ],
      url: '/entities/{fpId}/available_adhoc_vendors',
      ...options,
    },
  );
};

/**
 * Gets the beneficial owners of a business entity.
 */
export const getEntitiesByFpIdBusinessOwners = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdBusinessOwnersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdBusinessOwnersResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/business_owners',
    ...options,
  });
};

/**
 * Create (and optionally send) KYC links for beneficial owners awaiting KYC. Cannot be used for beneficials that have already completed KYC.
 */
export const postEntitiesByFpIdBusinessOwnersKycLinks = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdBusinessOwnersKycLinksData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostEntitiesByFpIdBusinessOwnersKycLinksResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/business_owners/kyc_links',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Gets the beneficial owners of a business entity.
 */
export const getEntitiesByFpIdBusinesses = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdBusinessesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdBusinessesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/businesses',
    ...options,
  });
};

/**
 * View the vault data for a specific entity (business or user)
 */
export const getEntitiesByFpIdData = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdDataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdDataResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/data',
    ...options,
  });
};

/**
 * Decrypts structured information about the AML hits for a AML risk signal.
 */
export const postEntitiesByFpIdDecryptAmlHitsBySignalId = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdDecryptAmlHitsBySignalIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostEntitiesByFpIdDecryptAmlHitsBySignalIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/decrypt_aml_hits/{signalId}',
    ...options,
  });
};

/**
 * View the documents uploaded for this vault.
 */
export const getEntitiesByFpIdDocuments = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdDocumentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdDocumentsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/documents',
    ...options,
  });
};

/**
 * View the documents uploaded for this vault.
 */
export const getEntitiesByFpIdDocumentsByDocumentIdentifier = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdDocumentsByDocumentIdentifierData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdDocumentsByDocumentIdentifierResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/documents/{documentIdentifier}',
    ...options,
  });
};

/**
 * Lists information about other vaults with duplicate information for a footprint vault.
 */
export const getEntitiesByFpIdDupes = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdDupesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdDupesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/dupes',
    ...options,
  });
};

/**
 * Get the linked bank accounts for an entity.
 */
export const getEntitiesByFpIdLinkedBankAccounts = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdLinkedBankAccountsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdLinkedBankAccountsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/linked_bank_accounts',
    ...options,
  });
};

/**
 * Allows a tenant to view a customer's registered webauthn credentials.
 */
export const getEntitiesByFpIdLiveness = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdLivenessData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdLivenessResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/liveness',
    ...options,
  });
};

/**
 * Lists the match signals for a footprint user.
 */
export const getEntitiesByFpIdMatchSignals = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdMatchSignalsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdMatchSignalsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/match_signals',
    ...options,
  });
};

/**
 * Get the list of playbooks this user has onboarded onto, ordered by timestamp descending. If a user has onboarded onto one playbook multiple times, there will be multiple onboardings. Useful to find the status from onboarding onto a specific playbook.
 */
export const getEntitiesByFpIdOnboardings = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdOnboardingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdOnboardingsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/onboardings',
    ...options,
  });
};

/**
 * Get a single onboarding by workflow ID for the given entity.
 */
export const getEntitiesByFpIdOnboardingsByOnboardingId = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdOnboardingsByOnboardingIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/onboardings/{onboardingId}',
    ...options,
  });
};

/**
 * Get all onboarding data for a specific onboarding, decrypted. The schema field describes the data type; if None, assume the value is a string.
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdData = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdDataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdOnboardingsByOnboardingIdDataResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/onboardings/{onboardingId}/data',
    responseTransformer: buildResponseTransformer([['data', 'value']]),
    ...options,
  });
};

/**
 * Lists the match signals for a footprint user.
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignals = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/onboardings/{onboardingId}/match_signals',
    ...options,
  });
};

/**
 * Lists the risk signals for a footprint user and onboarding.
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignals = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/onboardings/{onboardingId}/risk_signals',
    ...options,
  });
};

/**
 * Get the onboarding trace for a given onboarding
 */
export const getEntitiesByFpIdOnboardingsByOnboardingIdTrace = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdOnboardingsByOnboardingIdTraceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdOnboardingsByOnboardingIdTraceResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/onboardings/{onboardingId}/trace',
    responseTransformer: buildResponseTransformer([['entries', 'onboarding_data', 'value']]),
    ...options,
  });
};

/**
 * Request that Footprint review an entity's profile
 */
export const postEntitiesByFpIdRequestFpReview = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdRequestFpReviewData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdRequestFpReviewResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/request_fp_review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all incomplete reviews for an entity
 */
export const getEntitiesByFpIdReviews = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdReviewsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdReviewsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/reviews',
    ...options,
  });
};

/**
 * Lists the risk signals for a footprint user.
 */
export const getEntitiesByFpIdRiskSignals = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdRiskSignalsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdRiskSignalsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/risk_signals',
    ...options,
  });
};

/**
 * Retrieves the result of executing rules from the latest workflow decision made
 */
export const getEntitiesByFpIdRuleSetResult = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdRuleSetResultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdRuleSetResultResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/rule_set_result',
    ...options,
  });
};

/**
 * Retrieves the RuleSetResult for the given fp_id,rule_set_result_id
 */
export const getEntitiesByFpIdRuleSetResultByRuleSetResultId = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdRuleSetResultByRuleSetResultIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetEntitiesByFpIdRuleSetResultByRuleSetResultIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/rule_set_result/{ruleSetResultId}',
    ...options,
  });
};

/**
 * Decrypts structured information about the sentilink risk levels
 */
export const postEntitiesByFpIdSentilinkBySignalId = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdSentilinkBySignalIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdSentilinkBySignalIdResponses, ApiError, ThrowOnError>(
    {
      security: [
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Percy-Chat-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
      ],
      url: '/entities/{fpId}/sentilink/{signalId}',
      ...options,
    },
  );
};

/**
 * Update an entity's entity status.
 */
export const patchEntitiesByFpIdStatuses = <ThrowOnError extends boolean = true>(
  options: Options<PatchEntitiesByFpIdStatusesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchEntitiesByFpIdStatusesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Gets the timeline for a user.
 */
export const getEntitiesByFpIdTimeline = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdTimelineData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdTimelineResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/timeline',
    ...options,
  });
};

/**
 * Create an identified token for the provided fp_id and a link to the hosted flow that allows the user to complete the requested flow.
 */
export const postEntitiesByFpIdToken = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdTokenResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Lists the user insights for a Footprint user: the consolidated insights across every onboarding (no onboarding_id) followed by each onboarding's own insights
 */
export const getEntitiesByFpIdUserInsights = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdUserInsightsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdUserInsightsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/user_insights',
    ...options,
  });
};

/**
 * Works for either person or business entities. Deletes the provided fields from the provide vault.
 */
export const deleteEntitiesByFpIdVault = <ThrowOnError extends boolean = true>(
  options: Options<DeleteEntitiesByFpIdVaultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteEntitiesByFpIdVaultResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/vault',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns information on which fields are present in the vault.
 */
export const getEntitiesByFpIdVault = <ThrowOnError extends boolean = true>(
  options: Options<GetEntitiesByFpIdVaultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetEntitiesByFpIdVaultResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/vault',
    ...options,
  });
};

/**
 * Works for either person or business entities. Updates data in a vault.
 */
export const patchEntitiesByFpIdVault = <ThrowOnError extends boolean = true>(
  options: Options<PatchEntitiesByFpIdVaultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchEntitiesByFpIdVaultResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/vault',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Works for either person or business entities. Decrypts the specified list of fields from the provided vault.
 */
export const postEntitiesByFpIdVaultDecrypt = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdVaultDecryptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdVaultDecryptResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/vault/decrypt',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Works for either person or business entities. Checks if provided data is valid before adding it to the vault.
 */
export const postEntitiesByFpIdVaultIntegrity = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdVaultIntegrityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdVaultIntegrityResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/vault/integrity',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Checks if provided data is valid before adding it to the vault. Returns an HTTP 200 if there are no validation errors, or HTTP 400 with context describing validation errors if any.
 */
export const postEntitiesByFpIdVaultValidate = <ThrowOnError extends boolean = true>(
  options: Options<PostEntitiesByFpIdVaultValidateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostEntitiesByFpIdVaultValidateResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/entities/{fpId}/vault/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

export const getFail = <ThrowOnError extends boolean = true>(options?: Options<GetFailData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    url: '/fail',
    ...options,
  });
};

export const getHeaders = <ThrowOnError extends boolean = true>(options?: Options<GetHeadersData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    url: '/headers',
    ...options,
  });
};

/**
 * Returns 200 if the API server is running
 */
export const getHealth = <ThrowOnError extends boolean = true>(options?: Options<GetHealthData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    url: '/health',
    ...options,
  });
};

/**
 * Returns enclave health
 */
export const getHealthEnclave = <ThrowOnError extends boolean = true>(
  options?: Options<GetHealthEnclaveData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHealthEnclaveResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Protected-Custodian-Key',
        type: 'apiKey',
      },
    ],
    url: '/health/enclave',
    ...options,
  });
};

/**
 * Checks health of enclave decrypt operation
 */
export const getHealthEnclaveDecrypt = <ThrowOnError extends boolean = true>(
  options?: Options<GetHealthEnclaveDecryptData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetHealthEnclaveDecryptResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Protected-Custodian-Key',
        type: 'apiKey',
      },
    ],
    url: '/health/enclave_decrypt',
    ...options,
  });
};

/**
 * Bulk-hydrate the labeled [S#] sources for an investigation and, in the same call, resolve the caller's [S# <locator>] citations against each source's pinned content. Decrypted source data and citation evidence require manual review or decrypt-all permissions. Non-sensitive source handles remain available with tenant read permission. Scoped to the tenant.
 */
export const postInvestigationsByInvestigationIdSources = <ThrowOnError extends boolean = true>(
  options: Options<PostInvestigationsByInvestigationIdSourcesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostInvestigationsByInvestigationIdSourcesResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/investigations/{investigationId}/sources',
    responseTransformer: buildResponseTransformer([
      ['sources', 'citations', 'evidence', 'data', 'value'],
      ['sources', 'data', 'data', 'output'],
    ]),
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns basic info about the authed tenant
 */
export const getOrg = <ThrowOnError extends boolean = true>(options?: Options<GetOrgData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetOrgResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org',
    ...options,
  });
};

/**
 * Updates the basic information for the tenant
 */
export const patchOrg = <ThrowOnError extends boolean = true>(options: Options<PatchOrgData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List agents
 */
export const getOrgAgents = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAgentsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAgentsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents',
    ...options,
  });
};

/**
 * Create a new agent from a template. Use GET /org/agents/{agentId}/builder to load an existing agent's head into the builder.
 */
export const postOrgAgentsBuilder = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsBuilderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsBuilderResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/builder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Explain the supplied agent rules in plain language without saving or executing them.
 */
export const postOrgAgentsBuilderExplainRules = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsBuilderExplainRulesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsBuilderExplainRulesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/builder/explain_rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Draft rules from an instruction and the fields available before this rules task. Validates the proposal without saving or executing the graph.
 */
export const postOrgAgentsBuilderGenerateRules = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsBuilderGenerateRulesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsBuilderGenerateRulesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/builder/generate_rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Lists the tenant's remote MCP servers, without their header values.
 */
export const getOrgAgentsMcpServers = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAgentsMcpServersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAgentsMcpServersResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/mcp_servers',
    ...options,
  });
};

/**
 * Saves a remote MCP server the tenant's agents may call. The header value is sealed for Percy and never returned.
 */
export const postOrgAgentsMcpServers = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsMcpServersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsMcpServersResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/mcp_servers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Completes OAuth authorization with the code the provider sent back and saves the MCP server.
 */
export const postOrgAgentsMcpServersOauthComplete = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsMcpServersOauthCompleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsMcpServersOauthCompleteResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/mcp_servers/oauth/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Starts OAuth authorization for a new remote MCP server and returns the URL to send the user to.
 */
export const postOrgAgentsMcpServersOauthStart = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsMcpServersOauthStartData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsMcpServersOauthStartResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/mcp_servers/oauth/start',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Removes a remote MCP server. Agents still referencing it run without it.
 */
export const deleteOrgAgentsMcpServersByServerId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgAgentsMcpServersByServerIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgAgentsMcpServersByServerIdResponses, ApiError, ThrowOnError>(
    {
      security: [
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Percy-Chat-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
      ],
      url: '/org/agents/mcp_servers/{serverId}',
      ...options,
    },
  );
};

/**
 * Replaces the sealed header value of a remote MCP server.
 */
export const patchOrgAgentsMcpServersByServerId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgAgentsMcpServersByServerIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgAgentsMcpServersByServerIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/mcp_servers/{serverId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Starts OAuth authorization again for an existing remote MCP server, keeping its name and URL.
 */
export const postOrgAgentsMcpServersByServerIdOauthStart = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsMcpServersByServerIdOauthStartData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgAgentsMcpServersByServerIdOauthStartResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/mcp_servers/{serverId}/oauth/start',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns aggregate metrics for agent executions. Defaults to 24h timeframes for metrics
 */
export const getOrgAgentsMetrics = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAgentsMetricsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAgentsMetricsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/metrics',
    ...options,
  });
};

/**
 * Get status for an agent run, keyed by the workflow id returned from the run API
 */
export const getOrgAgentsRunsByWorkflowId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgAgentsRunsByWorkflowIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgAgentsRunsByWorkflowIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/runs/{workflowId}',
    ...options,
  });
};

/**
 * List the task templates that can be added to an agent as plain, editable tasks
 */
export const getOrgAgentsTaskCatalog = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAgentsTaskCatalogData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAgentsTaskCatalogResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/task_catalog',
    ...options,
  });
};

/**
 * List the agent templates that can be built, and what each one builds
 */
export const getOrgAgentsTemplates = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAgentsTemplatesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAgentsTemplatesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/templates',
    ...options,
  });
};

/**
 * List available tools for agents
 */
export const getOrgAgentsTools = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAgentsToolsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAgentsToolsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/tools',
    ...options,
  });
};

/**
 * Get a single agent by ID
 */
export const getOrgAgentsByAgentId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgAgentsByAgentIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgAgentsByAgentIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}',
    ...options,
  });
};

/**
 * Update an agent's metadata
 */
export const patchOrgAgentsByAgentId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgAgentsByAgentIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgAgentsByAgentIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get the current head of an agent's builder graph, or a specific historical version if `version_id` is provided.
 */
export const getOrgAgentsByAgentIdBuilder = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgAgentsByAgentIdBuilderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgAgentsByAgentIdBuilderResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/builder',
    ...options,
  });
};

/**
 * Apply a single mutation (add / update / remove / reorder a node, or update norms) to the head agent version graph. Creates a new immutable agent_version row and advances the head pointer.
 */
export const patchOrgAgentsByAgentIdBuilder = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgAgentsByAgentIdBuilderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgAgentsByAgentIdBuilderResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/builder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Publish the current head agent version by tagging it with a semver. The new tag must be strictly greater than the agent's most recently published version_tag.
 */
export const postOrgAgentsByAgentIdBuilderPublish = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsByAgentIdBuilderPublishData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsByAgentIdBuilderPublishResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/builder/publish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Restore the agent builder to a target version. If the target is an ancestor of the head the head pointer moves back (undo); if it's in the future chain it moves forward (redo); otherwise a new version is created at the head carrying the target's graph. Undoing past a published version is rejected.
 */
export const postOrgAgentsByAgentIdBuilderRestore = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsByAgentIdBuilderRestoreData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsByAgentIdBuilderRestoreResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/builder/restore',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Accept a batch of pending Percy suggestions in one transaction: apply each proposed operation to the head agent version's graph in request order, writing one immutable agent_version row per accepted suggestion. The whole batch fails if any suggestion can't be applied — nothing is accepted unless every suggestion applies cleanly.
 */
export const postOrgAgentsByAgentIdBuilderSuggestionsAccept = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsByAgentIdBuilderSuggestionsAcceptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgAgentsByAgentIdBuilderSuggestionsAcceptResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/builder/suggestions/accept',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Reject a batch of pending Percy suggestions in one transaction. Flips each suggestion row to `Rejected`; ids that are no longer pending are skipped. Does not touch the head graph.
 */
export const postOrgAgentsByAgentIdBuilderSuggestionsReject = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsByAgentIdBuilderSuggestionsRejectData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgAgentsByAgentIdBuilderSuggestionsRejectResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/builder/suggestions/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Paginated chain-walk of an agent's version history. The first page starts from the agent's most recently created version (the tip of the latest edit chain, even if the head currently sits on an older version due to undo) and walks backward via `base_version_id` pointers. Each item carries the operation that produced the version, the actor, timestamp, version tag, and whether the version was created from an AI suggestion.
 */
export const getOrgAgentsByAgentIdHistory = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgAgentsByAgentIdHistoryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgAgentsByAgentIdHistoryResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/history',
    ...options,
  });
};

/**
 * Paginated list of an agent's released versions — every row with a `version_tag` set, newest first. Returns the same `AgentVersionHistoryItem` shape as the history endpoint.
 */
export const getOrgAgentsByAgentIdReleases = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgAgentsByAgentIdReleasesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgAgentsByAgentIdReleasesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/releases',
    ...options,
  });
};

/**
 * Run a configured agent on an entity's investigation workflow.
 */
export const postOrgAgentsByAgentIdRun = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAgentsByAgentIdRunData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAgentsByAgentIdRunResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Describe what an agent does — its steps, the data it needs, the rules it applies and what it returns — for its latest published release.
 */
export const getOrgAgentsByAgentIdSummary = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgAgentsByAgentIdSummaryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgAgentsByAgentIdSummaryResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/agents/{agentId}/summary',
    ...options,
  });
};

/**
 * Lists the tenant's secret API keys
 */
export const getOrgApiKeys = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgApiKeysData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgApiKeysResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/api_keys',
    ...options,
  });
};

/**
 * Generates a new secret tenant api key.
 */
export const postOrgApiKeys = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgApiKeysData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgApiKeysResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/api_keys',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Updates an existing secret tenant api key.
 */
export const patchOrgApiKeysById = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgApiKeysByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgApiKeysByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/api_keys/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Permanently deactivates an existing tenant API key.
 */
export const postOrgApiKeysByIdDeactivate = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgApiKeysByIdDeactivateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgApiKeysByIdDeactivateResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/api_keys/{id}/deactivate',
    ...options,
  });
};

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific tenant secret API key.
 */
export const postOrgApiKeysByIdReveal = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgApiKeysByIdRevealData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgApiKeysByIdRevealResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/api_keys/{id}/reveal',
    ...options,
  });
};

/**
 * Returns a list of metadata for tenant Android apps.
 */
export const getOrgAppMetaAndroid = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAppMetaAndroidData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAppMetaAndroidResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/android',
    ...options,
  });
};

/**
 * Creates a tenant Android app metadata entry for the organization.
 */
export const postOrgAppMetaAndroid = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAppMetaAndroidData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAppMetaAndroidResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/android',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete a tenant android app metadata for the organization.
 */
export const deleteOrgAppMetaAndroidByMetaId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgAppMetaAndroidByMetaIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgAppMetaAndroidByMetaIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/android/{metaId}',
    ...options,
  });
};

/**
 * Updates the provided tenant android app metadata
 */
export const patchOrgAppMetaAndroidByMetaId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgAppMetaAndroidByMetaIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgAppMetaAndroidByMetaIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/android/{metaId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific android app metadata entry
 */
export const postOrgAppMetaAndroidByMetaIdReveal = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAppMetaAndroidByMetaIdRevealData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAppMetaAndroidByMetaIdRevealResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/android/{metaId}/reveal',
    ...options,
  });
};

/**
 * Returns a list of metadata for tenant ios apps.
 */
export const getOrgAppMetaIos = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAppMetaIosData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAppMetaIosResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/ios',
    ...options,
  });
};

/**
 * Creates a tenant ios app metadata entry for the organization.
 */
export const postOrgAppMetaIos = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAppMetaIosData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAppMetaIosResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/ios',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete a tenant iOS app metadata for the organization.
 */
export const deleteOrgAppMetaIosByMetaId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgAppMetaIosByMetaIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgAppMetaIosByMetaIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/ios/{metaId}',
    ...options,
  });
};

/**
 * Updates the provided tenant ios app metadata
 */
export const patchOrgAppMetaIosByMetaId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgAppMetaIosByMetaIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgAppMetaIosByMetaIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/ios/{metaId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Note, we make this a post because it does a decrypt operation. In the future, we may make an audit event for it
 * Decrypts a specific ios app metadata entry
 */
export const postOrgAppMetaIosByMetaIdReveal = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAppMetaIosByMetaIdRevealData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAppMetaIosByMetaIdRevealResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/app_meta/ios/{metaId}/reveal',
    ...options,
  });
};

/**
 * Get a list of appearences for a tenant
 */
export const getOrgAppearences = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAppearencesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAppearencesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/appearences',
    ...options,
  });
};

/**
 * Create a new appearance for a tenant
 */
export const postOrgAppearences = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAppearencesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAppearencesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/appearences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get an appearance for a tenant
 */
export const getOrgAppearencesByAppearanceId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgAppearencesByAppearanceIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgAppearencesByAppearanceIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/appearences/{appearanceId}',
    ...options,
  });
};

/**
 * Update an appearance for a tenant
 */
export const patchOrgAppearencesByAppearanceId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgAppearencesByAppearanceIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgAppearencesByAppearanceIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/appearences/{appearanceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload a new logo for the appearance.
 */
export const putOrgAppearencesByAppearanceIdLogo = <ThrowOnError extends boolean = true>(
  options: Options<PutOrgAppearencesByAppearanceIdLogoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<PutOrgAppearencesByAppearanceIdLogoResponses, ApiError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/appearences/{appearanceId}/logo',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Append a batch of operations to the appearance's pending proposal without applying it.
 */
export const postOrgAppearencesByAppearanceIdProposal = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAppearencesByAppearanceIdProposalData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgAppearencesByAppearanceIdProposalResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/appearences/{appearanceId}/proposal',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List a tenant's artifacts, newest first. Optionally narrow by investigation_id.
 */
export const getOrgArtifacts = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgArtifactsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgArtifactsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/artifacts',
    ...options,
  });
};

/**
 * Create a new artifact (writes version 1). Multipart upload with a `metadata` JSON part and a `file` binary part.
 */
export const postOrgArtifacts = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgArtifactsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgArtifactsResponses, ApiError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/artifacts',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Deactivate an artifact. The artifact will no longer appear in list or get queries.
 */
export const deleteOrgArtifactsByArtifactId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgArtifactsByArtifactIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgArtifactsByArtifactIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/artifacts/{artifactId}',
    ...options,
  });
};

/**
 * Stream the raw decrypted bytes of an artifact's latest version. `Content-Type` is the artifact's stored mime_type. `X-Artifact-Version-Id` identifies the version whose bytes are returned Additional metadata is available via `GET /org/artifacts` and `GET /org/artifacts/{id}/versions`.
 */
export const getOrgArtifactsByArtifactId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgArtifactsByArtifactIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/artifacts/{artifactId}',
    ...options,
  });
};

/**
 * Update artifact metadata. Currently only supports renaming the artifact.
 */
export const patchOrgArtifactsByArtifactId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgArtifactsByArtifactIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgArtifactsByArtifactIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/artifacts/{artifactId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List versions of an artifact (oldest first), without decrypting content. Offset-paginated.
 */
export const getOrgArtifactsByArtifactIdVersions = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgArtifactsByArtifactIdVersionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgArtifactsByArtifactIdVersionsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/artifacts/{artifactId}/versions',
    ...options,
  });
};

/**
 * Create a new version of an existing artifact. Multipart upload with a `metadata` JSON part and a `file` binary part. The artifact's mime_type is fixed at create time and cannot be changed here.
 */
export const postOrgArtifactsByArtifactIdVersions = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgArtifactsByArtifactIdVersionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgArtifactsByArtifactIdVersionsResponses, ApiError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/artifacts/{artifactId}/versions',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Stream the raw decrypted bytes of a specific artifact version. `Content-Type` is the parent artifact's stored mime_type. `X-Artifact-Version-Id` echoes the version_id whose bytes are returned  Version metadata is available via `GET /org/artifacts/{id}/versions`.
 */
export const getOrgArtifactsByArtifactIdVersionsByVersionId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgArtifactsByArtifactIdVersionsByVersionIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/artifacts/{artifactId}/versions/{versionId}',
    ...options,
  });
};

/**
 * Query audit events, in descending order of timestamp.
 */
export const getOrgAuditEvents = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAuditEventsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAuditEventsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/audit_events',
    ...options,
  });
};

/**
 * After the user has proven they own an email address, allow them to assume an
 * auth role for any tenant to which the email address has access.
 */
export const postOrgAuthAssumeRole = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAuthAssumeRoleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAuthAssumeRoleResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/auth/assume_role',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create a token scoped for use on the docs site
 */
export const postOrgAuthDocsToken = <ThrowOnError extends boolean = true>(
  options?: Options<PostOrgAuthDocsTokenData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostOrgAuthDocsTokenResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/auth/docs_token',
    ...options,
  });
};

/**
 * Request to authenticate via Google OAuth.
 */
export const getOrgAuthGoogleOauth = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgAuthGoogleOauthData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    url: '/org/auth/google_oauth',
    ...options,
  });
};

/**
 * Called from the front-end with the WorkOS code. Returns the authorization token needed for future requests as well as user information
 */
export const postOrgAuthLogin = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAuthLoginData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAuthLoginResponses, ApiError, ThrowOnError>({
    url: '/org/auth/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Logs out the authenticated principal and invalidates the session
 */
export const postOrgAuthLogout = <ThrowOnError extends boolean = true>(
  options?: Options<PostOrgAuthLogoutData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostOrgAuthLogoutResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/auth/logout',
    ...options,
  });
};

/**
 * Request to authenticate a user email. WorkOS will send the email a link to login. Once the user clicks the magic link, WorkOs will call the /workos/callback endpoint, at which point we authenticate the user
 */
export const postOrgAuthMagicLink = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAuthMagicLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAuthMagicLinkResponses, ApiError, ThrowOnError>({
    url: '/org/auth/magic_link',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Complete WorkOS MCP authorization for the signed-in membership
 */
export const postOrgAuthMcpComplete = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAuthMcpCompleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAuthMcpCompleteResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/auth/mcp/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Return the list of tenants that can be inherited by the authed user
 */
export const getOrgAuthRoles = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgAuthRolesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgAuthRolesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/auth/roles',
    ...options,
  });
};

/**
 * Fetch the SAML SSO URL for a given email address.
 */
export const postOrgAuthSamlSso = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgAuthSamlSsoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgAuthSamlSsoResponses, ApiError, ThrowOnError>({
    url: '/org/auth/saml_sso',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Every message-board thread for the tenant with its comments, newest thread first. Closed threads are included with deactivated_at set. Risk ops firm employees only.
 */
export const getOrgBoardThreads = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgBoardThreadsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgBoardThreadsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/board/threads',
    ...options,
  });
};

/**
 * Closes a message-board thread so agents stop commenting on it. The thread stays readable with deactivated_at set. Risk ops firm employees only.
 */
export const postOrgBoardThreadsByThreadIdDeactivate = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgBoardThreadsByThreadIdDeactivateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgBoardThreadsByThreadIdDeactivateResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/board/threads/{threadId}/deactivate',
    ...options,
  });
};

/**
 * Get the client security configuration.
 */
export const getOrgClientSecurityConfig = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgClientSecurityConfigData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgClientSecurityConfigResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/client_security_config',
    ...options,
  });
};

/**
 * Update the client security configuration.
 */
export const patchOrgClientSecurityConfig = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgClientSecurityConfigData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgClientSecurityConfigResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/client_security_config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Lists the credentials the caller may use: an agent's when `agent_id` is given (or the token belongs to an autopilot run), otherwise the caller's own.
 */
export const getOrgCredentials = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgCredentialsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgCredentialsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/credentials',
    ...options,
  });
};

/**
 * Saves a login Percy may use in a browser. The secret fields are sealed for the Percy sandbox and never returned to the dashboard.
 */
export const postOrgCredentials = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgCredentialsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgCredentialsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/credentials',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Revokes a credential. Only the user who saved it may revoke it; anyone else gets not found.
 */
export const deleteOrgCredentialsByCredentialId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgCredentialsByCredentialIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgCredentialsByCredentialIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/credentials/{credentialId}',
    ...options,
  });
};

/**
 * Unseals a credential for the Percy sandbox. Copilot sessions may unseal the credentials their user saved; autopilot runs may unseal the credentials shared with their agent. Anything else is not found.
 */
export const postOrgCredentialsByCredentialIdDecrypt = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgCredentialsByCredentialIdDecryptData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgCredentialsByCredentialIdDecryptResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/credentials/{credentialId}/decrypt',
    ...options,
  });
};

/**
 * List all active entity statuses for the organization, optionally filtered by entity type and deactivated statuses
 */
export const getOrgEntityStatuses = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgEntityStatusesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgEntityStatusesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/entity_statuses',
    ...options,
  });
};

/**
 * Get a single entity status by ID, including deactivated statuses
 */
export const getOrgEntityStatusesById = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgEntityStatusesByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgEntityStatusesByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/entity_statuses/{id}',
    ...options,
  });
};

/**
 * Deactivate (soft-delete) an entity status
 */
export const deleteOrgEntityStatusesBySlug = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgEntityStatusesBySlugData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgEntityStatusesBySlugResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/entity_statuses/{slug}',
    ...options,
  });
};

/**
 * Update an entity status and/or its entries
 */
export const patchOrgEntityStatusesBySlug = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgEntityStatusesBySlugData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgEntityStatusesBySlugResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/entity_statuses/{slug}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Lists the footprint wrapped metrics for a tenant.
 */
export const getOrgFootprintWrapped = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgFootprintWrappedData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/footprint_wrapped',
    ...options,
  });
};

/**
 * Returns a list of frequent notes for the organization.
 */
export const getOrgFrequentNotes = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgFrequentNotesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgFrequentNotesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/frequent_notes',
    ...options,
  });
};

/**
 * Creates a new frequent note for the organization.
 */
export const postOrgFrequentNotes = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgFrequentNotesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgFrequentNotesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/frequent_notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete a frequent note for the organization.
 */
export const deleteOrgFrequentNotesByFrequentNoteId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgFrequentNotesByFrequentNoteIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteOrgFrequentNotesByFrequentNoteIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/frequent_notes/{frequentNoteId}',
    ...options,
  });
};

/**
 * Returns the context for a specific node in a graph to help render the node's drawer.
 */
export const getOrgGraphsByGraphIdNodesByNodeIdContext = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgGraphsByGraphIdNodesByNodeIdContextData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrgGraphsByGraphIdNodesByNodeIdContextResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/graphs/{graphId}/nodes/{nodeId}/context',
    ...options,
  });
};

/**
 * Compile the given CEL programs against a node's position in the graph, returning the type each one resolves to. Lets the dashboard show an expression's type before it has been saved.
 */
export const postOrgGraphsByGraphIdNodesByNodeIdValidateExpressions = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgGraphsByGraphIdNodesByNodeIdValidateExpressionsResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/graphs/{graphId}/nodes/{nodeId}/validate_expressions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Validate a rule for a given conditional node
 */
export const postOrgGraphsByGraphIdNodesByNodeIdValidateRules = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgGraphsByGraphIdNodesByNodeIdValidateRulesResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/graphs/{graphId}/nodes/{nodeId}/validate_rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns a list of node_ids and searchable strings
 */
export const getOrgGraphsByGraphIdSearch = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgGraphsByGraphIdSearchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgGraphsByGraphIdSearchResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/graphs/{graphId}/search',
    ...options,
  });
};

/**
 * Query investigations (onboardings), in descending order of creation time.
 */
export const postOrgInvestigationsSearch = <ThrowOnError extends boolean = true>(
  options?: Options<PostOrgInvestigationsSearchData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostOrgInvestigationsSearchResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/investigations/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Get a single investigation by investigation ID.
 */
export const getOrgInvestigationsById = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgInvestigationsByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgInvestigationsByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/investigations/{id}',
    ...options,
  });
};

/**
 * For an investigation created by an agent run, returns the agent version's graph nodes, each with the completion timestamps and result of the latest trace entry for that node. Entries are empty when the investigation has no agent run.
 */
export const getOrgInvestigationsByIdTrace = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgInvestigationsByIdTraceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgInvestigationsByIdTraceResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/investigations/{id}/trace',
    ...options,
  });
};

/**
 * Returns a preview of the in-progress invoice for the month, if exists
 */
export const getOrgInvoicePreview = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgInvoicePreviewData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgInvoicePreviewResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/invoice_preview',
    ...options,
  });
};

/**
 * Retrieves all Lists for the Tenant
 */
export const getOrgLists = <ThrowOnError extends boolean = true>(options?: Options<GetOrgListsData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetOrgListsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists',
    ...options,
  });
};

/**
 * Creates a new List
 */
export const postOrgLists = <ThrowOnError extends boolean = true>(options: Options<PostOrgListsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<PostOrgListsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns events for a List.
 */
export const getOrgListsByIdTimeline = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgListsByIdTimelineData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgListsByIdTimelineResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists/{id}/timeline',
    ...options,
  });
};

/**
 * Delete the List
 */
export const deleteOrgListsByListId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgListsByListIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgListsByListIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists/{listId}',
    ...options,
  });
};

/**
 * Returns a blocklist.
 */
export const getOrgListsByListId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgListsByListIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgListsByListIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists/{listId}',
    ...options,
  });
};

/**
 * Updates an existing list
 */
export const patchOrgListsByListId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgListsByListIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgListsByListIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists/{listId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Retrieves all entries of a list
 */
export const getOrgListsByListIdEntries = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgListsByListIdEntriesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgListsByListIdEntriesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists/{listId}/entries',
    ...options,
  });
};

/**
 * Creates a new list entry
 */
export const postOrgListsByListIdEntries = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgListsByListIdEntriesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgListsByListIdEntriesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists/{listId}/entries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete the List
 */
export const deleteOrgListsByListIdEntriesByListEntryId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgListsByListIdEntriesByListEntryIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteOrgListsByListIdEntriesByListEntryIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/lists/{listId}/entries/{listEntryId}',
    ...options,
  });
};

/**
 * Upload a new logo for the organization.
 */
export const putOrgLogo = <ThrowOnError extends boolean = true>(options: Options<PutOrgLogoData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<PutOrgLogoResponses, ApiError, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/logo',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Returns info on the authed user.
 */
export const getOrgMember = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgMemberData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgMemberResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/member',
    ...options,
  });
};

/**
 * Updates the authed user.
 */
export const patchOrgMember = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgMemberData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgMemberResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/member',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Turns a dashboard feature preview on or off for the authed user.
 */
export const putOrgMemberFeaturePreviews = <ThrowOnError extends boolean = true>(
  options: Options<PutOrgMemberFeaturePreviewsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<PutOrgMemberFeaturePreviewsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/member/feature_previews',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns the list of in-progress KYC/KYB onboardings for the email associated with the logged-in dashboard user.
 */
export const getOrgMemberInProgressOnboardings = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgMemberInProgressOnboardingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgMemberInProgressOnboardingsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/member/in_progress_onboardings',
    ...options,
  });
};

/**
 * Returns a list of dashboard members for the tenant
 */
export const getOrgMembers = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgMembersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgMembersResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/members',
    ...options,
  });
};

/**
 * Create a new IAM user for the tenant. Sends an invite link via WorkOs
 */
export const postOrgMembers = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgMembersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgMembersResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/members',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Updates the provided member.
 */
export const patchOrgMembersByTenantUserId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgMembersByTenantUserIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgMembersByTenantUserIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/members/{tenantUserId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Deactivates the provided user.
 */
export const postOrgMembersByTenantUserIdDeactivate = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgMembersByTenantUserIdDeactivateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgMembersByTenantUserIdDeactivateResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/members/{tenantUserId}/deactivate',
    ...options,
  });
};

/**
 * Returns metrics to display on the dashboard home page.
 */
export const getOrgMetrics = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgMetricsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgMetricsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/metrics',
    ...options,
  });
};

export const postOrgOnboardingSession = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgOnboardingSessionData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgOnboardingSessionResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/onboarding/session',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * After a user finishes an interactive Footprint onboarding flow through one of our SDKs, your application will be given a validation token. This API allows you to exchange that short-lived validation token for the long-lived `fp_id` of the user who finished the flow. This also returns some information about the flow that the user has completed.
 */
export const postOrgOnboardingSessionValidate = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgOnboardingSessionValidateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgOnboardingSessionValidateResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/onboarding/session/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Copies the provided onboarding configuration into the provided tenant and provided sandbox mode.
 */
export const postOrgOnboardingConfigsByIdCopy = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgOnboardingConfigsByIdCopyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgOnboardingConfigsByIdCopyResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/onboarding_configs/{id}/copy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

export const postOrgOnboardings = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgOnboardingsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgOnboardingsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/onboardings',
    responseTransformer: buildResponseTransformer([['output']]),
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Fetch an onboarding by `onboarding_id` or `onboarding_external_id`. Returns the same response as `POST /onboardings`, including a freshly minted `continue_onboarding` token when the user still has steps left to complete.
 */
export const getOrgOnboardingsById = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgOnboardingsByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgOnboardingsByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/onboardings/{id}',
    responseTransformer: buildResponseTransformer([['output']]),
    ...options,
  });
};

/**
 * Percy meta query: search scoped vaults by structured filters. Returns each matching entity's fp_id along with its associated workflow_ids and playbook_ids.
 */
export const postOrgPercyEntitiesQuery = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgPercyEntitiesQueryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgPercyEntitiesQueryResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/percy/entities_query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns a list of playbooks owned by the tenant.
 */
export const getOrgPlaybooks = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgPlaybooksData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgPlaybooksResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks',
    ...options,
  });
};

/**
 * Creates a new playbook edit session. Updates to a playbook can be staged in the edit session before all being committed atomically
 */
export const postOrgPlaybooksEditSessions = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgPlaybooksEditSessionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgPlaybooksEditSessionsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/edit_sessions',
    responseTransformer: buildResponseTransformer([['test_entries', 'onboarding_data', 'value']]),
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get an existing playbook edit session without creating a new one.
 */
export const getOrgPlaybooksEditSessionsByEditSessionId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgPlaybooksEditSessionsByEditSessionIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrgPlaybooksEditSessionsByEditSessionIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/edit_sessions/{editSessionId}',
    responseTransformer: buildResponseTransformer([['test_entries', 'onboarding_data', 'value']]),
    ...options,
  });
};

/**
 * Apply the given operation to the graph.
 */
export const patchOrgPlaybooksEditSessionsByEditSessionId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgPlaybooksEditSessionsByEditSessionIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchOrgPlaybooksEditSessionsByEditSessionIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/edit_sessions/{editSessionId}',
    responseTransformer: buildResponseTransformer([['test_entries', 'onboarding_data', 'value']]),
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Commits the playbook edit session by making a new playbook version.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdCommit = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdCommitData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgPlaybooksEditSessionsByEditSessionIdCommitResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/edit_sessions/{editSessionId}/commit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Moves the work the legacy identify flow did before the graph ran onto the graph itself, as edits to the playbook edit session.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdModernize = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdModernizeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgPlaybooksEditSessionsByEditSessionIdModernizeResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/edit_sessions/{editSessionId}/modernize',
    responseTransformer: buildResponseTransformer([['test_entries', 'onboarding_data', 'value']]),
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Restore the graph to the provided log ID from an undo / redo operation.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdRestore = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdRestoreData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgPlaybooksEditSessionsByEditSessionIdRestoreResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/edit_sessions/{editSessionId}/restore',
    responseTransformer: buildResponseTransformer([['test_entries', 'onboarding_data', 'value']]),
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get an existing playbook edit session without creating a new one.
 */
export const postOrgPlaybooksEditSessionsByEditSessionIdRun = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgPlaybooksEditSessionsByEditSessionIdRunData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgPlaybooksEditSessionsByEditSessionIdRunResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/edit_sessions/{editSessionId}/run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Lists the available playbook templates for the gallery
 */
export const getOrgPlaybooksGallery = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgPlaybooksGalleryData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgPlaybooksGalleryResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/gallery',
    ...options,
  });
};

/**
 * Lists the available playbook templates
 */
export const getOrgPlaybooksTemplates = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgPlaybooksTemplatesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgPlaybooksTemplatesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/templates',
    ...options,
  });
};

/**
 * Returns a detailed view of a playbook owned by the tenant.
 */
export const getOrgPlaybooksById = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgPlaybooksByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgPlaybooksByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/{id}',
    ...options,
  });
};

/**
 * Updates an existing playbook's status.
 */
export const patchOrgPlaybooksById = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgPlaybooksByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgPlaybooksByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns a paginated list of all deployments (active and historical) for the given playbook.
 */
export const getOrgPlaybooksByPlaybookIdDeployments = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgPlaybooksByPlaybookIdDeploymentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgPlaybooksByPlaybookIdDeploymentsResponses, ApiError, ThrowOnError>(
    {
      security: [
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Percy-Chat-Authorization',
          type: 'apiKey',
        },
        {
          name: 'X-Fp-Dashboard-Authorization',
          type: 'apiKey',
        },
      ],
      url: '/org/playbooks/{playbookId}/deployments',
      ...options,
    },
  );
};

/**
 * Creates a new deployment for the given playbook, deactivating any existing active deployment.
 */
export const postOrgPlaybooksByPlaybookIdDeployments = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgPlaybooksByPlaybookIdDeploymentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgPlaybooksByPlaybookIdDeploymentsResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/{playbookId}/deployments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Returns the version history of onboarding configurations for the given playbook.
 */
export const getOrgPlaybooksByPlaybookIdVersions = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgPlaybooksByPlaybookIdVersionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgPlaybooksByPlaybookIdVersionsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/{playbookId}/versions',
    ...options,
  });
};

/**
 * Returns a detailed view of a specific playbook version.
 */
export const getOrgPlaybooksByPlaybookIdVersionsByVersionId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgPlaybooksByPlaybookIdVersionsByVersionIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrgPlaybooksByPlaybookIdVersionsByVersionIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/{playbookId}/versions/{versionId}',
    ...options,
  });
};

/**
 * Publishes the given version of the playbook and un-publishes the currently published version.
 */
export const postOrgPlaybooksByPlaybookIdVersionsByVersionIdPublish = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgPlaybooksByPlaybookIdVersionsByVersionIdPublishResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/playbooks/{playbookId}/versions/{versionId}/publish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List the organization's proxy configurations
 */
export const getOrgProxyConfigs = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgProxyConfigsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgProxyConfigsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/proxy_configs',
    ...options,
  });
};

/**
 * Create a new proxy configuration
 */
export const postOrgProxyConfigs = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgProxyConfigsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgProxyConfigsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/proxy_configs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Lists the request logs for a proxy config.
 */
export const getOrgProxyConfigsByConfigIdLogs = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgProxyConfigsByConfigIdLogsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgProxyConfigsByConfigIdLogsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/proxy_configs/{configId}/logs',
    ...options,
  });
};

/**
 * Get a proxy configuration with details
 */
export const getOrgProxyConfigsByProxyConfigId = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgProxyConfigsByProxyConfigIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgProxyConfigsByProxyConfigIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/proxy_configs/{proxyConfigId}',
    ...options,
  });
};

/**
 * Update an existing proxy configuration
 */
export const patchOrgProxyConfigsByProxyConfigId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgProxyConfigsByProxyConfigIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgProxyConfigsByProxyConfigIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/proxy_configs/{proxyConfigId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete organization's proxy configurations
 */
export const postOrgProxyConfigsByProxyConfigIdDeactivate = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgProxyConfigsByProxyConfigIdDeactivateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgProxyConfigsByProxyConfigIdDeactivateResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/proxy_configs/{proxyConfigId}/deactivate',
    ...options,
  });
};

/**
 * Returns the reporting embedded portal url.
 */
export const getOrgReportingEmbed = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgReportingEmbedData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgReportingEmbedResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/reporting_embed',
    ...options,
  });
};

/**
 * List review agents
 */
export const getOrgReviewAgents = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgReviewAgentsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgReviewAgentsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_agents',
    ...options,
  });
};

/**
 * Create a review agent
 */
export const postOrgReviewAgents = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgReviewAgentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgReviewAgentsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_agents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all reviews for a review agent
 */
export const getOrgReviewAgentsReviews = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgReviewAgentsReviewsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgReviewAgentsReviewsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_agents/reviews',
    ...options,
  });
};

/**
 * Update a review agent by ID
 */
export const patchOrgReviewAgentsById = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgReviewAgentsByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgReviewAgentsByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_agents/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List review agents
 */
export const getOrgReviewKinds = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgReviewKindsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgReviewKindsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_kinds',
    ...options,
  });
};

/**
 * Create a review kind
 */
export const postOrgReviewKinds = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgReviewKindsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgReviewKindsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_kinds',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update a review kind
 */
export const patchOrgReviewKindsById = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgReviewKindsByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgReviewKindsByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_kinds/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List all review queues for the organization
 */
export const getOrgReviewQueues = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgReviewQueuesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgReviewQueuesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_queues',
    ...options,
  });
};

/**
 * Create a new review queue
 */
export const postOrgReviewQueues = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgReviewQueuesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgReviewQueuesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_queues',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete a review queue
 */
export const deleteOrgReviewQueuesById = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgReviewQueuesByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgReviewQueuesByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_queues/{id}',
    ...options,
  });
};

/**
 * Get a specific review queue by ID
 */
export const getOrgReviewQueuesById = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgReviewQueuesByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgReviewQueuesByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_queues/{id}',
    ...options,
  });
};

/**
 * Update a review queue
 */
export const patchOrgReviewQueuesById = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgReviewQueuesByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgReviewQueuesByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_queues/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get the queue metrics for a queue
 */
export const getOrgReviewQueuesByQueueIdMetrics = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgReviewQueuesByQueueIdMetricsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgReviewQueuesByQueueIdMetricsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_queues/{queueId}/metrics',
    ...options,
  });
};

/**
 * Get the next review(s) for the current review agent
 */
export const postOrgReviewQueuesByQueueIdNext = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgReviewQueuesByQueueIdNextData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgReviewQueuesByQueueIdNextResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_queues/{queueId}/next',
    ...options,
  });
};

/**
 * List all reviews for a queue
 */
export const getOrgReviewQueuesByQueueIdReviews = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgReviewQueuesByQueueIdReviewsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgReviewQueuesByQueueIdReviewsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_queues/{queueId}/reviews',
    ...options,
  });
};

/**
 * List all review teams for the organization
 */
export const getOrgReviewTeams = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgReviewTeamsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgReviewTeamsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_teams',
    ...options,
  });
};

/**
 * Create a new review team
 */
export const postOrgReviewTeams = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgReviewTeamsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgReviewTeamsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_teams',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete a review team
 */
export const deleteOrgReviewTeamsById = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgReviewTeamsByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgReviewTeamsByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_teams/{id}',
    ...options,
  });
};

/**
 * Get a specific review team by ID
 */
export const getOrgReviewTeamsById = <ThrowOnError extends boolean = true>(
  options: Options<GetOrgReviewTeamsByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetOrgReviewTeamsByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_teams/{id}',
    ...options,
  });
};

/**
 * Update a review team
 */
export const patchOrgReviewTeamsById = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgReviewTeamsByIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgReviewTeamsByIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/review_teams/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Self assign a review to the current review agent
 */
export const postOrgReviewsByIdSelfAssign = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgReviewsByIdSelfAssignData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgReviewsByIdSelfAssignResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/reviews/{id}/self_assign',
    ...options,
  });
};

/**
 * Self unassign a review from the current review agent
 */
export const postOrgReviewsByIdSelfUnassign = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgReviewsByIdSelfUnassignData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgReviewsByIdSelfUnassignResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/reviews/{id}/self_unassign',
    ...options,
  });
};

/**
 * Start a review
 */
export const postOrgReviewsByIdStart = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgReviewsByIdStartData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgReviewsByIdStartResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/reviews/{id}/start',
    ...options,
  });
};

/**
 * Get metrics for a risk signals
 */
export const getOrgRiskSignalMetrics = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgRiskSignalMetricsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgRiskSignalMetricsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/risk_signal_metrics',
    ...options,
  });
};

/**
 * List all Footprint Risk Signals
 */
export const getOrgRiskSignalsSpec = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgRiskSignalsSpecData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgRiskSignalsSpecResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/risk_signals_spec',
    ...options,
  });
};

/**
 * Returns a list of IAM roles for the tenant.
 */
export const getOrgRoles = <ThrowOnError extends boolean = true>(options?: Options<GetOrgRolesData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetOrgRolesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/roles',
    ...options,
  });
};

/**
 * Create a new IAM role for the tenant.
 */
export const postOrgRoles = <ThrowOnError extends boolean = true>(options: Options<PostOrgRolesData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<PostOrgRolesResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Updates the provided IAM role.
 */
export const patchOrgRolesByTenantRoleId = <ThrowOnError extends boolean = true>(
  options: Options<PatchOrgRolesByTenantRoleIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<PatchOrgRolesByTenantRoleIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/roles/{tenantRoleId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Deactivates the provided IAM role.
 */
export const postOrgRolesByTenantRoleIdDeactivate = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgRolesByTenantRoleIdDeactivateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgRolesByTenantRoleIdDeactivateResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/roles/{tenantRoleId}/deactivate',
    ...options,
  });
};

/**
 * Fetch SDK version usage for a tenant.
 */
export const getOrgSdkVersion = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgSdkVersionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgSdkVersionResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/sdk_version',
    ...options,
  });
};

/**
 * Returns a list of Tags for the organization.
 */
export const getOrgTags = <ThrowOnError extends boolean = true>(options: Options<GetOrgTagsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetOrgTagsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/tags',
    ...options,
  });
};

/**
 * Creates a new Tag for the organization.
 */
export const postOrgTags = <ThrowOnError extends boolean = true>(options: Options<PostOrgTagsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<PostOrgTagsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete a tag for the organization.
 */
export const deleteOrgTagsByTagId = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrgTagsByTagIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteOrgTagsByTagIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/tags/{tagId}',
    ...options,
  });
};

/**
 * Returns the AWS external ID for the tenant if it exists
 */
export const getOrgVaultDrAwsPreEnrollment = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgVaultDrAwsPreEnrollmentData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgVaultDrAwsPreEnrollmentResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
    ],
    url: '/org/vault_dr/aws_pre_enrollment',
    ...options,
  });
};

/**
 * Generates an AWS external ID for the tenant if necessary.
 */
export const postOrgVaultDrAwsPreEnrollment = <ThrowOnError extends boolean = true>(
  options?: Options<PostOrgVaultDrAwsPreEnrollmentData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<PostOrgVaultDrAwsPreEnrollmentResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
    ],
    url: '/org/vault_dr/aws_pre_enrollment',
    ...options,
  });
};

/**
 * Enrolls the authorized tenant in Vault Disaster Recovery
 */
export const postOrgVaultDrEnroll = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgVaultDrEnrollData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgVaultDrEnrollResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
    ],
    url: '/org/vault_dr/enroll',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Reveals the wrapped record keys necessary to decrypt the Vault Disaster Recovery backups for the given fp_id fields
 */
export const postOrgVaultDrRevealWrappedRecordKeys = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgVaultDrRevealWrappedRecordKeysData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgVaultDrRevealWrappedRecordKeysResponses, ApiError, ThrowOnError>(
    {
      security: [
        {
          name: 'X-Footprint-Secret-Key',
          type: 'apiKey',
        },
      ],
      url: '/org/vault_dr/reveal_wrapped_record_keys',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  );
};

/**
 * Returns the status of Vault Disaster Recovery for the authenticated organization
 */
export const getOrgVaultDrStatus = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgVaultDrStatusData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgVaultDrStatusResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Footprint-Secret-Key',
        type: 'apiKey',
      },
    ],
    url: '/org/vault_dr/status',
    ...options,
  });
};

/**
 * List every supported vendor, along with the organization's integration for it if one is registered
 */
export const getOrgVendorIntegrations = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgVendorIntegrationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgVendorIntegrationsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/vendor_integrations',
    responseTransformer: buildResponseTransformer([
      ['apis', 'default_inputs'],
      ['apis', 'input_schema'],
      ['apis', 'output_schema'],
      ['credential_schema'],
    ]),
    ...options,
  });
};

/**
 * Register a vendor integration. Add its live and sandbox credentials with POST /org/vendor_integrations/{integrationId}/credentials
 */
export const postOrgVendorIntegrations = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgVendorIntegrationsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostOrgVendorIntegrationsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/vendor_integrations',
    responseTransformer: buildResponseTransformer([
      ['apis', 'default_inputs'],
      ['apis', 'input_schema'],
      ['apis', 'output_schema'],
      ['credential_schema'],
    ]),
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Add or replace a live or sandbox credential on a vendor integration
 */
export const postOrgVendorIntegrationsByIntegrationIdCredentials = <ThrowOnError extends boolean = true>(
  options: Options<PostOrgVendorIntegrationsByIntegrationIdCredentialsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PostOrgVendorIntegrationsByIntegrationIdCredentialsResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/vendor_integrations/{integrationId}/credentials',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Reveal the output of a vendor integration execution
 */
export const postOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdReveal = <
  ThrowOnError extends boolean = true,
>(
  options: Options<PostOrgVendorIntegrationsByIntegrationIdExecutionByExecutionIdRevealData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/vendor_integrations/{integrationId}/execution/{executionId}/reveal',
    ...options,
  });
};

/**
 * Returns the webhook portal url.
 */
export const getOrgWebhookPortal = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrgWebhookPortalData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetOrgWebhookPortalResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/org/webhook_portal',
    ...options,
  });
};

/**
 * Lists all access requests for the tenant
 */
export const getPrivateAccessRequests = <ThrowOnError extends boolean = true>(
  options?: Options<GetPrivateAccessRequestsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetPrivateAccessRequestsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/private/access_requests',
    ...options,
  });
};

/**
 * Creates a new access request
 */
export const postPrivateAccessRequests = <ThrowOnError extends boolean = true>(
  options: Options<PostPrivateAccessRequestsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostPrivateAccessRequestsResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/private/access_requests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Updates an access request (e.g. to approve it or extend it's expiration time)
 */
export const patchPrivateAccessRequestsByRequestId = <ThrowOnError extends boolean = true>(
  options: Options<PatchPrivateAccessRequestsByRequestIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    PatchPrivateAccessRequestsByRequestIdResponses,
    ApiError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/private/access_requests/{requestId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Allow a firm employee to impersonate a tenant
 */
export const postPrivateAssume = <ThrowOnError extends boolean = true>(
  options: Options<PostPrivateAssumeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostPrivateAssumeResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/private/assume',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Firm-employee-only: fetch any onboarding graph by ID plus the playbook  version that references it (if any). Used by the internal graph viewer to inspect graphs whose playbooks are hidden, deactivated, or absent.
 */
export const getPrivateGraphsByGraphId = <ThrowOnError extends boolean = true>(
  options: Options<GetPrivateGraphsByGraphIdData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetPrivateGraphsByGraphIdResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/private/graphs/{graphId}',
    ...options,
  });
};

/**
 * Performs health check to the RO database
 */
export const getRoStatus = <ThrowOnError extends boolean = true>(options?: Options<GetRoStatusData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    url: '/ro_status',
    ...options,
  });
};

/**
 * Returns health of services running
 */
export const getStatus = <ThrowOnError extends boolean = true>(options?: Options<GetStatusData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    url: '/status',
    ...options,
  });
};

/**
 * Returns health of services running
 */
export const getStatus2 = <ThrowOnError extends boolean = true>(options?: Options<GetStatus2Data, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<unknown, ApiError, ThrowOnError>({
    url: '/status2',
    ...options,
  });
};

/**
 * Reveals the contents of a vault proxy request log.
 */
export const postVaultProxyLogsByLogIdReveal = <ThrowOnError extends boolean = true>(
  options: Options<PostVaultProxyLogsByLogIdRevealData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<PostVaultProxyLogsByLogIdRevealResponses, ApiError, ThrowOnError>({
    security: [
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Percy-Chat-Authorization',
        type: 'apiKey',
      },
      {
        name: 'X-Fp-Dashboard-Authorization',
        type: 'apiKey',
      },
    ],
    url: '/vault_proxy/logs/{logId}/reveal',
    ...options,
  });
};
